export default "__VITE_ASSET__931e19bf__"